<script lang="ts">
  import Button from '$components/button/Button.svelte';
  import { onDestroy } from 'svelte';
  import { beforeNavigate } from '$app/navigation';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import { stateError } from '$states/error.svelte';
  import ModalSimple from '$components/modal/ModalSimple.svelte';
  import { copyToClipboard } from '$utils/copyToClipboard';
  import { showToast } from '$components/toast-manager';

  beforeNavigate(() => closeModal());

  onDestroy(() => stateError.set(null));

  let content = $derived(
    JSON.stringify({
      origin: window.location.origin,
      version: __VERSION__,
      date: new Date().toUTCString(),
      id: stateError.current?.eventId,
      message: stateError.current?.message,
      title: stateError.current?.title,
      error: stateError.current?.rawError,
    }),
  );

  const copy = async (): Promise<void> => {
    await copyToClipboard(content);

    showToast('positive', 'Copied to clipboard');
  };
</script>

<ModalSimple>
  {#snippet title()}
    <span class="typography-h5-semibold mb-3 block"
      >{stateError.current?.title ?? 'An unexpected error occurred'}</span>
    {#if stateError.current?.message}
      <p class="typography-body-l-regular">{stateError.current?.message}</p>
    {/if}
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Close" variant="tertiary" onclick={() => copy()}
      >Copy Details To Clipboard</Button>
    <Button ariaLabel="Close" variant="secondary" onclick={() => closeModal()}>Dismiss</Button>
    <span class="typography-body-m-regular my-2 block text-center text-foreground-subtle"
      >Error ID: {stateError.current?.eventId}</span>
  {/snippet}
</ModalSimple>
